import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

// import { ajax, sleep } from 'svs-utils/web';
import { AppLayout, useLogin } from 'svs-utils/react';

import { Home } from './components/index.js';

function AppRouter(props) {
    var login = useLogin();

    var loginComponentProps = {
        logout: login.logout,
        user: login.user,
    };

    return (
        <Routes>
            <Route path='/' element={<AppLayout />}>
                <Route path='*' element={<div>404</div>} />
                <Route path='404' element={<div>404</div>} />
                <Route path=':homePath' element={<Home {...loginComponentProps} />}>
                    <Route path=':homePath2' element={<Home {...loginComponentProps} />}></Route>
                </Route>
                <Route index element={<Navigate to='/flightlogs' />} />
            </Route>
        </Routes>
    );
}

export default AppRouter;
